module.exports = __webpack_public_path__ + "static/media/gameplay3.da43d20c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Spill/static/gameplay3.png
// module id = 189
// module chunks = 0